import { Component, OnInit } from '@angular/core';
import {TextUtils} from "../../../../../shared/utils/text-utils";

@Component({
    selector: 'db-customers-table',
    templateUrl: './customers-table.component.html',
    styleUrls: ['./customers-table.component.scss'],
    standalone: false
})
export class CustomersTableComponent implements OnInit {
  public heads: string[] = [
    TextUtils.getText('text_customerId'),
    TextUtils.getText('text_name'),
    TextUtils.getText('text_email'),
    TextUtils.getText('text_orders'),
    TextUtils.getText('text_totalSpent')
  ];

  constructor() { }

  ngOnInit() {
  }

}
